import { axiosAPI } from './API';
import { IDevice, ILocation, IPingLocationResponse, IPingDeviceResponse } from 'interfaces';

// Singleton for pinging devices
class _PingService {

    public pingDevices = (devices: IDevice[]): Promise<IPingDeviceResponse> => {
        const p = axiosAPI.post<IPingDeviceResponse>('/devices/ping', {devices: devices})
            .then((resp) => {
                return resp.data;
            });

        p.catch((err) => {
            console.error('Error pinging devices: ', err);
        });

        return p;
    }

    public pingLocations = (locations: ILocation[]): Promise<IPingLocationResponse> => {
        const p = axiosAPI.post<IPingLocationResponse>('/locations/ping', {locations: locations})
            .then((resp) => {
                return resp.data;
            });

        p.catch((err) => {
            console.error('Error pinging locations: ', err);
        });

        return p;
    }
}

export const PingService = new _PingService();